import { render, staticRenderFns } from "./SeparateFileSelectModal.vue?vue&type=template&id=11f408b1&scoped=true&lang=pug"
import script from "./SeparateFileSelectModal.vue?vue&type=script&lang=ts"
export * from "./SeparateFileSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./SeparateFileSelectModal.vue?vue&type=style&index=0&id=11f408b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f408b1",
  null
  
)

export default component.exports